import Repository from './Repository';
import ListRequest from '@/models/ListRequest';
import { CreateRestaurantIngredient } from '@/models/Ingredient/CreateRestaurantIngredient';
import { UpdateRestaurantIngredient } from '@/models/Ingredient/UpdateRestaurantIngredient';
import { DeleteRestaurantIngredients } from '@/models/Ingredient/DeleteRestaurantIngredients';
import { SearchIngredients } from '@/models/Ingredient/SearchIngredients';


const resource = '/ingredients';

export default {
  listIngredientSearch(listRequest: ListRequest) {
    return Repository.post(`${resource}/ListIngredientSearch`, listRequest, { withCredentials: true });
  },
  listRestaurantIngredients(listRequest: ListRequest) {
    return Repository.post(`${resource}/ListRestaurantIngredients`, listRequest, { withCredentials: true });
  },
  createRestaurantIngredient(createRestaurantIngredient: CreateRestaurantIngredient) {
    return Repository.post(`${resource}/CreateRestaurantIngredient`, createRestaurantIngredient, { withCredentials: true });
  },
  updateRestaurantIngredient(updateRestaurantIngredient: UpdateRestaurantIngredient) {
    return Repository.post(`${resource}/UpdateRestaurantIngredient`, updateRestaurantIngredient, { withCredentials: true });
  },
  deleteRestaurantIngredients(deleteRestaurantIngredients: DeleteRestaurantIngredients) {
    return Repository.post(`${resource}/DeleteRestaurantIngredients`, deleteRestaurantIngredients, { withCredentials: true });
  },
  searchIngredients(searchIngredients: SearchIngredients) {
    return Repository.post(`${resource}/SearchIngredients`, searchIngredients, { withCredentials: true });
  },
  searchIngredientsByFoodCode(searchIngredients: SearchIngredients) {
    return Repository.post(`${resource}/SearchIngredientsByFoodCode`, searchIngredients, { withCredentials: true })
  },
  getIngredientDetails(ingredientId: number) {
    return Repository.post(`${resource}/GetIngredientDetails`, { ingredientId }, { withCredentials: true });
  },
  getAutoCorrectSerchTerm(searchTerms: string[]) {
    return Repository.post(`${resource}/AutoCorrectSearchTerm`, { SearchTerms: searchTerms }, { withCredentials: true });
  },
  createIngredientSearchFailure(failure: any) {
    return Repository.post(`${resource}/CreateIngredientSearchFailure`, failure, { withCredentials: true });
  },
  listIngredientSearchFailures(failure: any) {
    return Repository.post(`${resource}/ListIngredientSearchFailures`, failure, { withCredentials: true });
  },
  searchCategoryDensities(searchTerm: string, categoryDensityId: number|string) {
    return Repository.get(`${resource}/SearchCategoryDensities?searchTerm=${searchTerm}&categoryDensityId=${categoryDensityId}`, { withCredentials: true });
  },
};
